// components/Footer/Footer.jsx
import React from "react";
import "./Footer.css";
import img from "../../assests/whitelogo.png";

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-container">
//         <div className="footer-content">
//           <div className="footer-section">
//             {/* <h3 className="footer-logo">jobhub manpower solution</h3> */}
//             <img src={img} alt="jobhub manpower solution Logo" className="footer-logo-image" />
//             <p>Your trusted event management partner</p>
//           </div>

//           <div className="footer-section">
//             <h4>Connect With Us</h4>
//             <div className="footer-social">
//               <a
//                 href="https://www.facebook.com/share/1B62nXKy5x/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="social-link"
//                 aria-label="Visit our Facebook page"
//               >
//                 <i className="fab fa-facebook-f"></i>
//               </a>
//               <a
//                 href="https://x.com/jobhub manpower solution/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="social-link"
//                 aria-label="Visit our X profile"
//               >
//                 <svg
//                   viewBox="0 0 24 24"
//                   width="1em"
//                   height="1em"
//                   aria-hidden="true"
//                   focusable="false"
//                   style={{ display: "inline-block", verticalAlign: "middle", color: "#fff" }}
//                 >
//                   <path fill="#fff" d="M18.244 2H21l-6.5 7.43L22 22h-6.56l-4.6-6.05L5.6 22H3l7-8.01L2 2h6.72l4.17 5.58L18.244 2zm-1.15 18h1.63L7.01 4h-1.7l11.784 16z" />

//                 </svg>
//               </a>

//               <a
//                 href="https://www.instagram.com/jobhub manpower solution/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="social-link"
//                 aria-label="Visit our Instagram page"
//               >
//                 <i className="fab fa-instagram"></i>
//               </a>
//             </div>
//           </div>

//           <div className="footer-section">
//             <h4>Download App</h4>
//             <button
//               className="google-play-btn"
//               onClick={() => alert("jobhub manpower solution app coming soon to Google Play!")}
//               style={{
//                 background: "none",
//                 border: "none",
//                 cursor: "pointer",
//                 padding: 0,
//               }}
//             >
//               <img
//                 src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
//                 alt="Get it on Google Play"
//               />
//             </button>
//           </div>
//         </div>

//         <div className="footer-bottom">
//           <p>&copy; 2024 Notch Brothers Hospitality Private Limited, All Rights Reserved</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <img
              src={img}
              alt="jobhub manpower solution Logo"
              className="footer-logo-image"
            />
            <p>Your trusted event management partner</p>
          </div>

          <div className="footer-section">
            <h4>Connect With Us</h4>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/jobhubmanpowersolution"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Visit our Facebook page"
              >
                <i className="fab fa-facebook-f"></i>
              </a>

              {/* <a
                href="https://x.com/jobhub manpower solution/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Visit our X profile"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="1em"
                  height="1em"
                  aria-hidden="true"
                  focusable="false"
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  <path
                    fill="currentColor"
                    d="M18.244 2H21l-6.5 7.43L22 22h-6.56l-4.6-6.05L5.6 22H3l7-8.01L2 2h6.72l4.17 5.58L18.244 2zm-1.15 18h1.63L7.01 4h-1.7l11.784 16z"
                  />
                </svg>
              </a> */}

              <a
                href="https://www.instagram.com/jobhubmanpowersolution"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Visit our Instagram page"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* <div className="footer-section">
            <h4>Download App</h4>
            <button
              className="google-play-btn"
              onClick={() =>
                alert("jobhub manpower solution app coming soon to Google Play!")
              }
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
              />
            </button>
          </div> */}
        </div>

        <div className="footer-bottom">
          <p>
            &copy; 2017 jobhub manpower Solution, All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
